import { Injectable } from '@angular/core';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';
import { SLLayer } from 'src/app/model/sl-layer';
import { Subject } from 'rxjs';
// import { ClassificationService } from 'src/app/model/api-services/classification.service';
import { ColorClassification } from 'src/app/types/color-classification';

@Injectable({
	providedIn: 'root'
})
export class ColorGenDialogService {
	public request$: Subject<any> = new Subject();

	constructor(/*private classSvc: ClassificationService*/) { }

	Show(handler: AnyHandler, layer: SLLayer, extClass: ColorClassification = null) {
		this.request$.next({ handler: (handler), layer: (layer), extClass: (extClass) });
	}
}

